

import React from 'react';

function PrivacyPolicyPage() {
    return (
        <div className="privacy-policy-page" >
            <h1 className="legal-header">Privacy Policy for Arillian Farm</h1>
            {
                <h4>
                    Privacy Policy for Arillian Farm

                    Last Updated: April 13, 2025

                    This Privacy Policy describes how Arillian Farm (the "Site," "we," "us," or "our") collects, uses, and shares information about you when you use our website [yourwebsiteurl.com] (the "Site").

                    Information We Collect

                    We may collect the following types of information:

                    * **Information You Provide Directly:** This may include your name, email address, and any other information you provide when you contact us through the Site (e.g., via a contact form).
                    * **Automatically Collected Information:** When you access and use our Site, we may automatically collect certain information about your visit, including:
                    * Your IP address
                    * Your browser type and operating system
                    * The pages you view on our Site
                    * The dates and times of your visits
                    * Referring website addresses

                    How We Use Your Information

                    We may use the information we collect for the following purposes:

                    * To respond to your inquiries and provide customer support.
                    * To analyze website usage and improve our Site.
                    * To communicate with you about updates or other information related to Arillian Farm (if you have opted in to receive such communications).
                    * To protect the security and integrity of our Site.

                    Sharing Your Information

                    We may share your information with third-party service providers who assist us in operating our Site, conducting our business, or servicing you (e.g., website hosting, analytics providers). These third parties are obligated to keep your information confidential and use it only for the purposes for which we disclose it to them.

                    We may also disclose your information if required to do so by law or in response to a valid legal request.

                    Your Choices

                    You may choose not to provide us with certain personal information, but this may limit your ability to use certain features of our Site.

                    If you have subscribed to receive communications from us, you may unsubscribe at any time by following the instructions provided in those communications.

                    Cookies and Similar Technologies

                    We may use cookies and similar tracking technologies to collect information about your browsing activities on our Site. You can control cookies through your browser settings.

                    Data Security

                    We take reasonable measures to protect the information we collect from unauthorized access, use, or disclosure. However, no method of transmission over the internet or method of electronic storage is completely secure.

                    Links to Other Websites

                    Our Site may contain links to third-party websites. We are not responsible for the privacy practices of these other websites. We encourage you to review the privacy policies of any third-party sites you visit.

                    Children's Privacy

                    Our Site is not directed to children under the age of 13, and we do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.

                    Changes to This Privacy Policy

                    We may update this Privacy Policy from time to time. We will post any changes on this page and update the "Last Updated" date at the top. Your continued use of the Site after any changes constitutes your acceptance of the new Privacy Policy.

                    Contact Us

                    If you have any questions about this Privacy Policy, please contact us at:

                    arillianfarm@gmail.com


                </h4>
            }
        </div>
    );
}

export default PrivacyPolicyPage;